import { createRouter, createWebHistory } from "vue-router";

const routes = [
  { path: "/", component: () => import("@/views/index/index-three.vue") },
  { path: "/about-us", component: () => import("@/views/about-us.vue") },
  { path: "/blog", component: () => import("@/views/blog/blog-page.vue") },
  {
    path: "/blog-detail/:id",
    component: () => import("@/views/blog/blog-detail.vue"),
  },
  { path: "/faq", component: () => import("@/views/faq-page.vue") },
  { path: "/contact", component: () => import("@/views/contact-page.vue") },
  {
    path: "/grid",
    component: () => import("@/views/property/grid-page.vue"),
    name: "gridArea",
  },
  {
    path: "/grid/:id",
    component: () => import("@/views/property/grid-page.vue"),
    name: "gridAreaId",
  },
  {
    path: "/property/:id",
    component: () => import("@/views/property/single-property-1.vue"),
    name: "singleProperty",
  },
  // Project routes
  {
    path: "/projects",
    component: () => import("@/views/project/projects-page.vue"),
    name: "projectsList",
  },
  {
    path: "/project/:id",
    component: () => import("@/views/project/project-detail.vue"),
    name: "projectDetail",
  },
  {
    path: "/:catchAll(.*)*",
    name: "NotFoundCatchAll",
    component: () => import("@/views/error-page.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
